import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const RecentlyUsedVideoWrapper = styled.div`
  width: 169px;
  height: 96px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  background-size: contain;
  cursor: pointer;
  background-color: ${COLORS.primaryLight};

  &:hover {
    .preview-button {
      display: flex;
    }
  }

  @media (max-width: 400px) {
    width: 163px;
    height: 90px;
  }
`

export const RecentlyUsedVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const Duration = styled.div`
  position: absolute;
  left: 4px;
  bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  color: white;
  font-size: 8px;
  background-color: ${COLORS.secondaryExtraDark};
  border-radius: 4px;
`

export const PreviewButton = styled.div.attrs({ className: 'preview-button' })`
  display: none;
  position: absolute;
  right: 8px;
  top: 8px;
  height: 16px;
  width: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};
  @media (max-width: 768px) {
    display: flex;
  }
`

export const PreviewContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 800px;
`

export const VideoPreviewPopupFooter = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`
export const VideoPreviewPopupVideo = styled.video`
  aspect-ratio: 16/9;
  margin-top: 20px;
`

export const FileName = styled.p`
  font-size: 14px;
  max-width: 40%;
`
